import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {EstimateType} from "@estimate/types/estimate.types";
import {RootState} from "@src/store";
import {Maybe} from "@src/types/global.types";
import {getEstimate} from "@estimate/utils/axios";

export interface EstimateStateType {
    estimate: Maybe<EstimateType>,
    isShowEstimateFileEdiUploadModal: boolean,
}

const initialState: EstimateStateType = {
    estimate: null,
    isShowEstimateFileEdiUploadModal: false,
}

export const fetchEstimate = createAsyncThunk(
    'estimate/fetch',
    async (estimateId: string, thunkAPI): Promise<EstimateType> => {
        return await getEstimate(estimateId);
    }
);

export const refreshEstimate = createAsyncThunk(
    'estimate/refresh',
    async (_, thunkAPI) => {
        const state = thunkAPI.getState() as RootState;
        const estimateId = state.estimate.estimate?.id;

        if (estimateId) {
            return thunkAPI.dispatch(fetchEstimate(estimateId));
        }
    }
);

export const estimateSlice = createSlice({
    name: 'estimate',
    initialState,
    reducers: {
        setEstimate: (state, action: PayloadAction<Maybe<EstimateType>>) => {
            state.estimate = action.payload;
        },
        clearEstimate: (state) => {
            state.estimate = null;
        },
        showEstimateFileEdiUploadModal: (state) => {
            state.isShowEstimateFileEdiUploadModal = true;
        },
        hideEstimateFileEdiUploadModal: (state) => {
            state.isShowEstimateFileEdiUploadModal = false;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchEstimate.fulfilled, (state, action: PayloadAction<EstimateType>) => {
            state.estimate = action.payload;
        })
    },
})

export const estimateState = (state: RootState): EstimateStateType => state.estimate;
export const estimate = (state: RootState): EstimateType => state.estimate.estimate;
export const isShowEstimateFileEdiUploadModal = (state: RootState): boolean => state.estimate.isShowEstimateFileEdiUploadModal;
export const { setEstimate, clearEstimate } = estimateSlice.actions;
export const { showEstimateFileEdiUploadModal, hideEstimateFileEdiUploadModal } = estimateSlice.actions;
export default estimateSlice.reducer;